import { gql } from "@apollo/client"
import { FullTeamProfileFragment } from "../FullTeamProfile/fragments"
import { LikeTeamActionFragment } from "../LikeTeamAction/fragments"

export const TEAM_PROFILE_MODAL_QUERY = gql`
    query TeamProfileModalQuery($team: String!) {
        recruitingTeam(uuid: $team) {
            id
            ...FullTeamProfileFragment
            ...LikeTeamAction_team
        }
    }
    ${FullTeamProfileFragment}
    ${LikeTeamActionFragment}
`
